import { isBlank, isPresent } from '@seedlang/utils';

export const normaliseMembershipTypeName = (membershipTypeName) => {
  if (isBlank(membershipTypeName)) {
    return null;
  } else if (membershipTypeName.endsWith('Membership')) {
    return membershipTypeName;
  } else if (membershipTypeName.endsWith('Member')) {
    return membershipTypeName.replace(/Member$/, 'Membership');
  }
  return `${membershipTypeName} Membership`;
}

export const getPodcastAccessSubText = (worksheet, membershipTypes = []) => {
  const accessStatus = worksheet?.accessStatus;
  const podcastMembershipTypeId = worksheet?.podcastEpisode?.podcast?.podcastMembershipTypes?.[0]?.membershipTypeId;
  const podcastMembershipType = membershipTypes.find(membershipType =>
    String(membershipType.id) === String(podcastMembershipTypeId),
  );
  const normalisedMembershipTypeName = normaliseMembershipTypeName(podcastMembershipType?.name);

  if (
    accessStatus?.reason === 'upgrade' &&
    accessStatus?.hasAccess === false &&
    isPresent(worksheet?.podcastEpisode) &&
    isPresent(worksheet?.youtubeUrl) &&
    isPresent(normalisedMembershipTypeName)
  ) {
    return `You need at least a ${normalisedMembershipTypeName} to access podcast content.`;
  }
  return null;
}
